// Replace direct database calls with API calls to backend

export async function getPost(id: string | number) {
  try {
    const response = await fetch(`${process?.env?.NEXT_PUBLIC_API_URL}/posts/${id}`);
    if (!response.ok) {
      throw new Error('Failed to fetch post');
    }
    const data = await response.json();
    return data.post || data;
  } catch (error) {
    console.error('Error fetching post:', error);
    throw error;
  }
}

export async function getPostDetails(id: string | number) {
  // Same as getPost for now - backend returns full details
  return getPost(id);
}

export async function getPosts(filter?: any, page = 1, pageSize = 10) {
  try {
    const params = new URLSearchParams({
      page: page.toString(),
      limit: pageSize.toString(),
      ...(filter && { filter: JSON.stringify(filter) })
    });
    
    // Add auth token if available (for authenticated features) but don't require it
    const token = localStorage.getItem('auth_token');
    const headers: Record<string, string> = {
      'Content-Type': 'application/json'
    };
    if (token) {
      headers['Authorization'] = `Bearer ${token}`;
    }
    
    const response = await fetch(`${process?.env?.NEXT_PUBLIC_API_URL}/posts?${params}`, {
      headers
    });
    if (!response.ok) {
      throw new Error('Failed to fetch posts');
    }
    return await response.json();
  } catch (error) {
    console.error('Error fetching posts:', error);
    throw error;
  }
}

export async function incrementViewCount(postId: string | number) {
  try {
    const response = await fetch(`${process?.env?.NEXT_PUBLIC_API_URL}/posts/${postId}/view`, {
      method: 'POST',
      headers: {
        'Authorization': `Bearer ${localStorage.getItem('auth_token')}`
      }
    });
    if (!response.ok) {
      throw new Error('Failed to increment view count');
    }
    return await response.json();
  } catch (error) {
    console.error('Error incrementing view count:', error);
    // Don't throw - view count is not critical
  }
}